<div class="wrapper py-5">
  <div class="container" role="status">
    <div class="text-center" [class]="type">
      <img class="icon" [src]="messageIcon" alt="">
      <h3 class="title">{{ messageTitle }}</h3>
      <p class="content">{{ messageContent }}</p>
    </div>
  </div>
</div>
